// src/context/LeavingSiteModalContext.js

import React, { createContext, useState, useContext } from "react";

const LeavingSiteModalContext = createContext();

export const LeavingSiteModalProvider = ({ children }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [externalLink, setExternalLink] = useState(null);

	const showLeavingSiteModal = (link) => {
		setExternalLink(link);
		setIsVisible(true);
	};

	const hideLeavingSiteModal = () => {
		setIsVisible(false);
		setExternalLink(null);
	};

	// Make the "show" function available globally so we can call it in gatsby-browser.js
	if (typeof window !== "undefined") {
		window.___showLeavingSiteModal = showLeavingSiteModal;
	}

	return (
		<LeavingSiteModalContext.Provider
			value={{
				isVisible,
				externalLink,
				showLeavingSiteModal,
				hideLeavingSiteModal,
			}}
		>
			{children}
		</LeavingSiteModalContext.Provider>
	);
};

export const useLeavingSiteModal = () => useContext(LeavingSiteModalContext);
